module.exports = __webpack_public_path__ + "static/media/iconeSheduleActive.db0fe144.svg";